<template>
  <div>
    <header-page :title="'Site statuses'" :hasBackLink="false" />

    <div class="filters-container">
      <div class="filters-block">
        <div class="search">
          <input-text v-model="search_text" />
          <div
            v-if="isShowClear"
            class="main-button lg ml-15"
            @click="clearFilters"
          >
            <div>Clear</div>
          </div>
        </div>
        <div class="button">
          <div v-if="false" class="main-button lg orange" @click="setFilters">
            <div class="icon" v-html="Filter"></div>
            <div>Filters</div>
          </div>
        </div>
      </div>
      <div class="selected-filters" v-if="selectedFilters.length">
        <div v-for="item in selectedFilters" :key="item.text">
          <div class="icon" @click="removeFilter(item.id)" v-html="Cross"></div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>

    <grid
      v-model:columns="columns"
      v-model="rows"
      :options="options"
      :page="page"
      :per_page="per_page"
      :newRowComponent="newRowComponent"
      :isHideNewRowComponent="isHideNewRowComponent"
      :countRows="countRows"
      :search_text="search_textToGrid"
      @deleteRow="deleteRow"
      @nextPage="nextPage"
      @prevPage="prevPage"
      @saveNewRow="saveNew"
      @saveRow="save"
      @setPerPage="setPerPage"
      @sortRows="fetchData"
    />
    <set-filters v-if="isVisibleFilters" v-model="isVisibleFilters" />
  </div>
</template>

<script>
import { shallowRef } from 'vue'
import NewRow from '@/components/NewRows/NewRowSiteStatus'
import { fetchData, urls } from '@/utils/urls.js'
import { hasAccess, permissions } from '@/utils/permissions'
import { listMixin } from '@/utils/list-mixin'
import { GrigOptions } from '@/models/grid-options'
import { GridColumn } from '@/models/grid-column'

export default {
  name: 'SiteStatuses',
  mixins: [listMixin],

  data() {
    let colsKeyUrlIndex = 0
    return {
      options: new GrigOptions({
        isSelectable: false,
        isEditable: hasAccess(permissions.update_site_status),
        isAdd: hasAccess(permissions.create_site_status),
        isDelete: hasAccess(permissions.delete_site_status),
        addButtonText: 'Add site status',
        getDeleteContent: async (rows) => {
          if (!rows) return ``
          let query = `page=1&per_page=all`
          let sites = await fetchData(
            urls.sites,
            'GET',
            null,
            query + `&site_status_f=` + rows[0].site_status
          )
          let count = sites?.count || 0

          if (!count) {
            this.options.deleteModalOptions.hideYes = false
            return `<div class="mb-10">Are you sure you want to delete site status?</div>`
          } else {
            this.options.deleteModalOptions.hideYes = true
            return `<div class="mb-10">
              You can’t delete the statuse till it’s assigned to existing sites.
                ${sites.rows.map((item) => `<div>• ${item.url}</div>`).join('')}
              </div>`
          }
        },
      }),

      columns: [
        new GridColumn({
          keyUrl: 's' + colsKeyUrlIndex++,
          key: 'site_status',
          text: 'Site status',
        }),
      ],
      newRowComponent: shallowRef(NewRow),
    }
  },

  created() {
    this.setDataFromQueryParams() // 3
    this.fetchData()
  },

  methods: {
    saveNew(params) {
      this.setNewEntity(params)
      this.addRow()
    },

    save(params) {
      this.editRow(params)
    },

    setNewEntity(params) {
      for (let key in params) {
        this.newEntity[key] = params[key]
      }
    },

    async editRow(params) {
      this.$store.commit('setIsLoading', true)
      const id = params.id
      delete params.id

      let result = await fetchData(
        urls.siteStatuses + `/${id}`,
        'POST',
        this.bodyToSave(params)
      )
      if (!result?.detail) {
        let siteRow = this.rows.find((item) => item.id === id)
        for (const key in params) {
          if (key in siteRow) siteRow[key] = params[key]
        }

        this.isHideNewRowComponent = true
        this.$nextTick(() => {
          this.isHideNewRowComponent = false
        })
      } else console.error(result.detail)

      this.$store.commit('setIsLoading', false)
    },

    async addRow() {
      this.$store.commit('setIsLoading', true)

      let result = await fetchData(
        urls.siteStatusesCreate,
        'POST',
        this.bodyToSave(this.newEntity)
      )
      if (!result?.detail) {
        this.rows.unshift(result)
        this.isHideNewRowComponent = true
        this.$nextTick(() => {
          this.isHideNewRowComponent = false
        })

        this.newEntityToDefault()
      } else {
        this.isHideNewRowComponent = false
        console.error(result.detail)
      }

      this.$store.commit('setIsLoading', false)
    },

    async deleteRow(id) {
      this.$store.commit('setIsLoading', true)

      let result = await fetchData(urls.siteStatuses + `/${id}`, 'DELETE')
      if (!result?.detail) {
        const idx = this.rows.findIndex((item) => item.id === id)
        this.rows.splice(idx, 1)
      } else console.error(result.detail)

      this.$store.commit('setIsLoading', false)
    },

    async fetchData() {
      this.setQueryParams()

      if (this.isLoading) return

      this.$store.commit('setIsLoading', true)
      let query = `page=${this.page}&per_page=${this.per_page}`
      let prevSearch_text = this.search_text.value
      if (this.search_text.value?.length > 2) {
        query += `&search_text=${this.search_text.value}`
      }

      query += this.queryToSort()

      let result = await fetchData(urls.siteStatuses, 'GET', null, query)

      this.rows = result?.rows || []

      this.countRows = result?.count || 0
      this.search_textToGrid = this.search_text.value
      this.$store.commit('setIsLoading', false)

      if (
        this.search_text.value?.length > 2 &&
        prevSearch_text !== this.search_text.value
      )
        this.fetchData()
    },

    setFilters() {
      this.isVisibleFilters = !this.isVisibleFilters
    },
  },
}
</script>
